import {defineStore} from "pinia";
import {ref} from "vue";
import type {ThemeTypes} from "@common/types/theme/ThemeType";

type SnackbarMessage = {
    text: string;
    color?: string;
    timeout?: number;
    close: () => void;
};
export const useToastStore = defineStore('snackbar', () => {

    const queue = ref([]);


    function ajouter({ text, color, timeout = 5000 }: { text: string; color?: string; timeout?: number }) {

        const snackbar: SnackbarMessage = {
            text: text,
            color,
            timeout,
            close: () => {
                const index = queue.value.indexOf(snackbar);
                if (index !== -1) queue.value.splice(index, 1);
            }
        };

        queue.value.push(snackbar);
    }



    return {
        ajouter,
        queue
    };



});